/* eslint-disable max-classes-per-file */
import axios from 'axios';
import { ClientClosedRequestError, NotAuthenticatedError, ServerError } from '@services/HttpErrorsService';

let shuttleRootPath;

const ShuttleService = {
  cancelCurrentCall() {
    if (this.controller) {
      this.controller.abort();
    }
  },
  async get(rootPath, planId) {
    shuttleRootPath = rootPath;

    this.controller = new AbortController();
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/${shuttleRootPath}`, {
        params : { planId },
        signal: this.controller.signal,
      });
      const { data } = response;

      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error:', error);
      if (axios.isCancel(error)) {
        throw new ClientClosedRequestError();
      }
      if (error.response?.status === 401) {
        throw new NotAuthenticatedError();
      }
      throw new ServerError();
    }
  },
};

export default ShuttleService;

// Copyright © 2023 Micruity Inc.
